import { Box, CircularProgress, GridLegacy as Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EditStateActions } from '~/components/EditStateActions';
import { SolaForceHeading } from '~/components/SolaForceHeading';
import { useSelectedEmployeeId } from '~/hooks/employee';
import {
  EditCustomDataFields,
  ReadCustomDataFields,
} from '~/legacy-components/CustomDataFields';

import { prefetchCustomPosition } from './data';
import { useCustomPosition } from './useCustomPosition';
import { useSxStyles } from './useStyles';

export const CustomPositionTab = () => {
  const { selectedEmployeeId } = useSelectedEmployeeId();
  const empId = String(selectedEmployeeId);
  const [editMode, setEditMode] = useState(false);
  const {
    isLoading,
    canEdit,
    readFieldData,
    editFieldData,
    control,
    isSubmitSuccessful,
    submitCount,
    handleFormSubmit,
    reset,
  } = useCustomPosition(empId);
  useEffect(() => {
    if (isSubmitSuccessful) {
      setEditMode(false);
      prefetchCustomPosition(empId);
    }
  }, [empId, isSubmitSuccessful, submitCount]);

  const { contentPadding, spinner } = useSxStyles();
  const { t } = useTranslation();
  return (
    <Box sx={contentPadding}>
      <SolaForceHeading heading={t('laCustomData')}>
        <EditStateActions
          canEdit={canEdit && editFieldData.length > 0}
          readMode={!editMode}
          onEdit={() => setEditMode(true)}
          onSave={async (e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            await handleFormSubmit();
          }}
          onCancel={() => {
            setEditMode(false);
            reset();
          }}
        />
      </SolaForceHeading>
      {isLoading ? (
        <Box sx={spinner}>
          <CircularProgress size={25} />
        </Box>
      ) : (
        <form>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={1} alignItems="center">
              {editMode ? (
                editFieldData.length ? (
                  editFieldData.map((f, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                      <EditCustomDataFields
                        control={control}
                        key={`${index}/${f.name}`}
                        {...f}
                      />
                    </Grid>
                  ))
                ) : (
                  <></>
                )
              ) : readFieldData.length ? (
                readFieldData.map((f, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <ReadCustomDataFields key={`${index}/${f.name}`} {...f} />
                  </Grid>
                ))
              ) : (
                <></>
              )}
            </Grid>
          </Box>
        </form>
      )}
    </Box>
  );
};
